import React, { Component } from "react";
import { DropdownButton, MenuItem } from "react-bootstrap";
import Alert from "sweetalert-react";
import Loading from "../../../../components/Loading";
import * as Http from "../../../../http";
import * as Business from "../../../../utils/business";
import ReportChild from "./ReportChild";

const dicSearchOptions = {
  report_date: "Report Date",
  file_name: "Report Name",
  approval_by: "Approver",
};

class ReportTable extends Component {
  state = {
    searchOption: "report_date",
    searchValue: "",
    items: [],
    loading: true,
  };

  batchWillDelete = null;

  componentDidMount() {
    const hash = window.location.hash;
    const qIdx = hash.indexOf("?");
    this.autoOpenReport =
      qIdx !== -1
        ? new URLSearchParams(hash.slice(qIdx)).get("reportName")
        : null;
    this.reportChildRefs = {};
    this.getListFile();
  }

  getListFile = () => {
    Http.getListBatch(Business.COMPONENT.RAROC).then((data) => {
      if (data && data.Success) {
        let listData = [];
        for (let index = 0; index < data.Data.length; index++) {
          const element = data.Data[index];
          if (!element) continue;

          if (element.file_name.startsWith("RAROC")) {
            element.timestamp = new Date(element.upload_time).getTime();
            listData.push(element);
          }
        }
        listData = listData.sort((a, b) => {
          return b.timestamp - a.timestamp;
        });
        this.setState({ items: listData, loading: false }, () => {
          if (
            this.autoOpenReport &&
            this.reportChildRefs[this.autoOpenReport]
          ) {
            this.reportChildRefs[this.autoOpenReport].show();
          }
        });
      }
    });
  };

  search = () => {
    const objSearch = {
      report_date:
        this.state.searchOption === "report_date"
          ? this.state.searchValue
          : null,
      file_name:
        this.state.searchOption === "file_name" ? this.state.searchValue : null,
      approval_by:
        this.state.searchOption === "approval_by"
          ? this.state.searchValue
          : null,
    };

    Http.getListBatch(Business.COMPONENT.RAROC, objSearch).then((data) => {
      if (data && data.Success) {
        let listData = [];
        for (let index = 0; index < data.Data.length; index++) {
          const element = data.Data[index];
          if (!element) continue;

          if (element.file_name.startsWith("RAROC")) {
            element.timestamp = new Date(element.upload_time).getTime();
            listData.push(element);
          }
        }
        listData = listData.sort((a, b) => {
          return b.timestamp - a.timestamp;
        });
        this.setState({
          items: listData,
          loading: false,
        });
      }
    });
  };

  deleteListItems = () => {
    Http.deleteBatch(Business.COMPONENT.RAROC, this.batchWillDelete).then(
      (res) => {
        if (res.Success) {
          this.getListFile();
        }
      },
    );
    this.batchWillDelete = null;
  };

  onDelete = (reportName) => {
    this.batchWillDelete = reportName;
    this.setState({
      showDeleteAlert: true,
    });
  };

  render() {
    if (this.state.loading)
      return (
        <div style={{ height: Business.getHeightContent() }}>
          <Loading size="small" />
        </div>
      );

    return (
      Business.isHasRole([Business.ROLE_DEFINE_MAP.ICAAP_VIEW_REPORT]) && (
        <div className="card">
          <div className="header" style={{ marginBottom: "10px" }}>
            <h4 className="title">Report list</h4>
          </div>
          <div className="content table-responsive table-full-width">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "20px",
                gap: "8px",
              }}
            >
              <div style={{ display: "inline", flexShrink: 0 }}>
                <DropdownButton
                  title={dicSearchOptions[this.state.searchOption]}
                  bsSize="small"
                  id={`dropdown-size-${1}`}
                >
                  <MenuItem
                    onSelect={(eventKey, event) => {
                      this.setState({ searchOption: eventKey });
                    }}
                    eventKey={`approval_by`}
                  >
                    {"Approver"}
                  </MenuItem>
                  <MenuItem divider />
                  <MenuItem
                    onSelect={(eventKey, event) => {
                      this.setState({ searchOption: eventKey });
                    }}
                    eventKey={`file_name`}
                  >
                    {"Report Name"}
                  </MenuItem>
                  <MenuItem divider />
                  <MenuItem
                    onSelect={(eventKey, event) => {
                      this.setState({ searchOption: eventKey });
                    }}
                    eventKey={`report_date`}
                  >
                    {"Report Date"}
                  </MenuItem>
                  <MenuItem divider />
                </DropdownButton>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flex: 1,
                  gap: "8px",
                }}
              >
                <input
                  type="text"
                  style={{ height: "30px", flex: 1 }}
                  className="form-control"
                  id="search_content"
                  onChange={(event) => {
                    this.setState({ searchValue: event.target.value });
                  }}
                />
                <button
                  type="button"
                  disabled={this.state.progressValue > 0}
                  className="btn btn-primary"
                  style={{
                    backgroundColor: "#FFE600",
                    borderColor: "#7F7E82",
                    borderRadius: "3px",
                    fontWeight: 600,
                    flexShrink: 0,
                    height: "30px",
                    fontSize: "10px",
                  }}
                  onClick={() => this.search()}
                >
                  Search
                </button>
              </div>
            </div>
            <table className="table table-hover table-striped">
              <thead>
                <tr>
                  <th>Report Date</th>
                  <th>Report Name</th>
                  <th>Approver</th>
                  <th>Approval Time</th>
                  <th>Uploader</th>
                  <th>Upload Time</th>
                </tr>
              </thead>
              <tbody>
                {this.state.items.map((item) => (
                  <tr key={item.file_name}>
                    <td>{Business.convertToDate(item.report_date)}</td>
                    <td>
                      <ReportChild
                        report={item}
                        ref={(r) => {
                          if (r) this.reportChildRefs[item.file_name] = r;
                        }}
                      />
                    </td>
                    <td>{item.approval_by}</td>
                    <td>{Business.convertToFullDate(item.approval_time)}</td>
                    <td>{item.upload_by}</td>
                    <td>{Business.convertToFullDate(item.upload_time)}</td>
                    <td className="text-right">
                      {Business.isHasRole([
                        Business.ROLE_DEFINE_MAP.ICAAP_DELETE_REPORT,
                      ]) ? (
                        <a
                          rel="tooltip"
                          aria-disabled="true"
                          className="btn btn-info btn-simple btn-xs"
                          data-original-title="View Profile"
                          onClick={() => this.onDelete(item.file_name)}
                        >
                          <i
                            style={{ fontSize: 23, color: "red" }}
                            className="pe-7s-trash"
                          ></i>
                        </a>
                      ) : (
                        <div></div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <Alert
            title="Are you sure?"
            show={this.state.showDeleteAlert}
            text="You will not be able to recover this report!"
            showCancelButton
            onConfirm={() => {
              this.setState({ showDeleteAlert: false });
              this.deleteListItems();
            }}
            onCancel={() => {
              this.setState({ showDeleteAlert: false });
              this.batchWillDelete = null;
            }}
          />
        </div>
      )
    );
  }
}

export default ReportTable;



// WEBPACK FOOTER //
// src/pages/Raroc/Report/Reports/ReportTable.js